import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => ({});

const debug = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.ADD_DEBUG) {
    return assign({}, state, payload);
  } else {
    return state;
  }
};

export default debug;
